import { BaseRouteService } from 'core/services';

class TrackingDashboardRouteService extends BaseRouteService {
	constructor() {
		super();
	}

	shipmentsSummary(filter) {
		return super.get('dashboard/tracking-shipments-summary{?shippedDateFrom,shippedDateTo}', null, filter);
	}

	shipments() {
		return super.create('shipment-infos/search');
	}
}

export default TrackingDashboardRouteService;